/*
 * @Author: wangzhu10 wangzhu10@jd.com
 * @Date: 2022-06-06 09:59:15
 * @LastEditors: wangzhu10 wangzhu10@jd.com
 * @LastEditTime: 2022-12-28 19:28:58
 */
import Vue from 'vue'
import router from './router'
import store from './store/index'
import App from './App.vue'
import axios from 'axios'
// import 'amfe-flexible'
import 'lib-flexible'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import './assets/iconfont/iconfont.css'
import './assets/iconfont/iconfont.js'
import './assets/style/font.css'
import animated from 'animate.css';
import { getQueryString } from './utils/lib';
import { Boot } from "@wangeditor/editor";
import topicModule from "@/components/wang-editor/topic";

Boot.registerModule(topicModule);

import VConsole from 'vconsole'
import {
  Button,
  Tab,
  Tabs,
  Image as VanImage,
  Divider,
  Icon,
  Sticky,
  Swipe,
  SwipeItem,
  List,
  PullRefresh,
  Popup,
  Field,
  Toast,
  Loading,
  Lazyload,
  Search,
  Empty,
  Uploader,
  Sidebar,
  SidebarItem,
  Tag,
  Switch,
  Dialog,
  Calendar,
  Progress,
  CheckboxGroup,
  Checkbox,
  Radio,
  RadioGroup,
  Badge,
  DropdownMenu,
  DropdownItem,
  Popover,
  Picker
} from 'vant';

Vue.config.productionTip = false

Vue.directive('title', {
  inserted: function (el) {
    document.title = el.dataset.title
  }
})

Vue.use(Picker);
Vue.use(Popover);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Button)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(VanImage)
Vue.use(Divider)
Vue.use(Icon)
Vue.use(Sticky)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(List)
Vue.use(PullRefresh)
Vue.use(Popup)
Vue.use(Field)
Vue.use(Toast)
Vue.use(Loading)
Vue.use(Lazyload)
Vue.use(Search)
Vue.use(Empty)
Vue.use(Uploader)
Vue.use(Sidebar)
Vue.use(SidebarItem)
Vue.use(Tag)
Vue.use(Switch)
Vue.use(Dialog)
Vue.use(Calendar)
Vue.use(Progress)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Badge)

Vue.use(VueQuillEditor, {
  readOnly: true,
  placeholder: '.',
  modules: {
    toolbar: []
  },
  theme: 'snow'
})

Vue.use(animated)

if (location.href.indexOf('yuanhuicai1') > -1 || location.href.indexOf('tianzezhong') > -1 || location.href.indexOf('lixin901') > -1 ){
  new VConsole()
}

if (!isMobile()) {
  
  const jagileDomain = 'http://xingyun.jd.com/shendeng'
  const pathname = location.pathname;
  const pathnameAry = pathname.match(/\d+/g)
  const search = location.search;
  const queryAry = search.match(/\d+/g)
  if (location.href.indexOf('yearReport') > -1) {
    new Vue({
      router,
      store,
      render: h => h(App),
    }).$mount('#app')
  } else {
    if (window.location.pathname.includes('/articleDetail') && window.location.hostname.includes('shendengh5.jd.com')) {
      // 兼容shendengh5域名
      const searchStr = `?jdme_router=jdme://web/202206081297?url=` + encodeURIComponent(`http://sd.jd.com/article/${queryAry[0]}`)
      window.location.href=`${jagileDomain}/article/detail/${queryAry[0]}${searchStr}`
    } else if (window.location.pathname.includes('/bbs/') || window.location.pathname.includes('/article/') || window.location.pathname.includes('/codeShow/') || window.location.pathname.includes('/personal') || window.location.pathname.includes('/column/') || window.location.pathname.includes('/circle/')) {
      if (window.location.pathname.includes('/personal')) {
        const id = getQueryString('id');
        const searchStr = `?jdme_router=jdme://web/202206081297?url=` + encodeURIComponent(`http://sd.jd.com/personal?id=${id}`)
        window.location.href=`${jagileDomain}/personal/home/${id}${searchStr}`
      } else {
        let type = 'article';
        if (window.location.pathname.includes('/bbs/')) {
          type = 'bbs'
        } 
        if (window.location.pathname.includes('/codeShow/')) {
          type = 'codeShow'
        }
        if (window.location.pathname.includes('/column/')) {
          type = 'column'
        }
        if (window.location.pathname.includes('/circle/')) {
          type = 'circle'
        }
        
        const searchStr = location.search ? location.search + `&jdme_router=jdme://web/202206081297?url=` + encodeURIComponent(`http://sd.jd.com/${type}/${pathnameAry[0]}${location.search}`) : `?jdme_router=jdme://web/202206081297?url=` + encodeURIComponent(`http://sd.jd.com/${type}/${pathnameAry[0]}`)
        console.log(pathnameAry, searchStr)
        window.location.href=`${jagileDomain}/${type}/detail/${pathnameAry[0]}${searchStr}`
      }
    } else if (window.location.pathname.includes('/read-rank')) {
      window.location.href = jagileDomain + '/reading-rank'
    } else if (window.location.pathname.includes('/pdf-preview/')) {
      window.location.href = jagileDomain + `/pdfPreview/${pathnameAry[0]}`
    } else if(window.location.pathname.includes('/programmer-day')) {
       window.location.href = jagileDomain + '/programmer-day'
    } else{
      let origin = +getQueryString('type') === 1 ? '/bbs/home' : '/article/home';
      let query = '';

      // 畅聊详情页
      if (getQueryString('orgCode')) {
        query = `?orgCode=${getQueryString('orgCode')}`
      }
      if (window.location.pathname.includes('/topic')) {
        origin = '/topic/detail'
        query = `?topic=${getQueryString('topic')}`
      }
      window.location.href = jagileDomain + origin + query
    }
  }
} else {
  console.log('===location===' ,window.location)
  const localUid = localStorage.getItem('uid')
  if (window.navigator.userAgent.indexOf('JDME') > -1) {
    if (window.location.pathname.includes('/withOutAuth')) {
      new Vue({ router, store, render: h => h(App) }).$mount("#app");
    } else {
      const param = { appKey: "shendeng", callback: function(data) {
          axios({
            method: "get",
            url: `/api/v1/user/getBbsId`,
            headers: {
              "Content-Type": "application/json",
              "ShenDeng-bbs-backend-User": "jingMe",
              "ShenDeng-Bbs-Backend-JingMe-Code": data.code
            },
            withCredentials: true
          })
            .then(res => {
              const { code } = res.data;
              if (code === 200) {
                window.jmeUid = res.data.data;
                localStorage.setItem("uid", res.data.data);
                console.log("uid", res.data.data);
                new Vue({
                  router,
                  store,
                  render: h => h(App)
                }).$mount("#app");
              }
              if (code === 403) {
                window.jme.browser.openUrl({
                  url: `${process.env
                    .VUE_APP_DOMAIN_URL}/withOutAuth?isHideShareButton=1`,
                  closeBrowser: true
                });
                return Promise.reject(res);
              }
            })
            .catch(err => {
              console.log("err", err);
              if (localUid) {
                new Vue({
                  router,
                  store,
                  render: h => h(App)
                }).$mount("#app");
              }
            });
        } };
      window.jme.login.getAuthorizationCode(param);
    }
    
  } else {
    new Vue({
      router,
      store,
      render: h => h(App),
    }).$mount('#app')
  }
}

function isMobile() {
  let ua = navigator.userAgent
  let flag = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|MicroMessenger/i.test(ua);
  return flag;
}